function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'black-teal': '','black-white': '','black': 'rgb(0, 0, 0)','black-frost': 'rgb(0, 0, 0)','blue': 'rgb(99, 137, 199)','blush-frost': 'rgb(225, 148, 142)','brown': 'rgb(99, 92, 82)','cardinal': 'rgb(140, 11, 66)','carolina-blue': 'rgb(75, 156, 211)','columbia-blue': 'rgb(185, 217, 235)','crimson': 'rgb(140, 11, 66)','dark-blue': 'rgb(28, 46, 100)','dark-brown': 'rgb(64, 54, 52)','dark-green': 'rgb(32, 55, 48)','dark-grey': 'rgb(89, 89, 89)','desert-tan-heather': 'rgb(164, 148, 125)','gold': 'rgb(253, 215, 0)','grey': 'rgb(192, 192, 192)','grey-frost': 'rgb(89, 89, 89)','heather-charcoal': 'rgb(89, 89, 89)','heather-grey': 'rgb(192, 192, 192)','kelly': 'rgb(2, 144, 80)','lavender': 'rgb(153, 102, 204)','light-blue': 'rgb(134, 187, 237)','light-green': 'rgb(187, 222, 198)','light-grey-black': '','light-grey': 'rgb(218, 218, 218)','light-pink': 'rgb(251, 211, 215)','maroon': 'rgb(83, 40, 57)','natural': 'rgb(243, 241, 228)','navy': 'rgb(28, 46, 100)','oatmeal': 'rgb(233, 229, 217)','orange': 'rgb(255, 128, 0)','pink': 'rgb(199, 65, 138)','purple': 'rgb(65, 44, 100)','red': 'rgb(255, 0, 0)','royal': 'rgb(0, 0, 255)','safety-orange': 'rgb(255, 103, 0)','safety-yellow': 'rgb(238, 210, 2)','tan': 'rgb(164, 148, 125)','tan-maroon': '','teal': 'rgb(71, 140, 137)','turquoise': 'rgb(64, 224, 208)','vegas-gold': 'rgb(197, 179, 88)','white': 'rgb(255, 255, 255)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
